import React, { useEffect, useState } from 'react';
import { api, ApiError } from './api';
import { EstadoError } from './EstadoError';

export default function Kardex() {
  const hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const hace30 = new Date(Date.now() - 30 * 86400000 - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const [productos, setProductos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [movimientos, setMovimientos] = useState([]);
  const [filtros, setFiltros] = useState({ producto_id: '', desde: hace30, hasta: hoy, tipo: '' });
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const cargar = async () => {
    setCargando(true); setError('');
    try {
      const qs = new URLSearchParams();
      Object.entries(filtros).forEach(([k, v]) => { if (v) qs.set(k, v); });
      const data = await api.get(`/api/kardex?${qs.toString()}`);
      setMovimientos(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err instanceof ApiError ? err.mensaje : 'No se pudo cargar el kardex.');
    } finally { setCargando(false); }
  };

  useEffect(() => {
    Promise.all([api.get('/api/productos'), api.get('/api/kardex/tipos')])
      .then(([p, t]) => { setProductos(Array.isArray(p) ? p : []); setTipos(Array.isArray(t) ? t : []); })
      .catch(() => {});
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) return <EstadoError mensaje={error} onReintentar={cargar} />;

  return (
    <div style={{ padding: '20px', background: '#f8fafc', minHeight: '80vh' }}>
      <h2 style={{ marginTop: 0, color: '#0f172a' }}>📚 Kardex de stock</h2>
      <div style={{ background: 'white', padding: '15px', borderRadius: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'end', marginBottom: '15px' }}>
        <Campo label="Producto">
          <select value={filtros.producto_id} onChange={(e) => setFiltros({ ...filtros, producto_id: e.target.value })} style={input}>
            <option value="">Todos</option>
            {productos.map((p) => <option key={p.id} value={p.id}>{p.descripcion}</option>)}
          </select>
        </Campo>
        <Campo label="Tipo">
          <select value={filtros.tipo} onChange={(e) => setFiltros({ ...filtros, tipo: e.target.value })} style={input}>
            <option value="">Todos</option>
            {tipos.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </Campo>
        <Campo label="Desde"><input type="date" value={filtros.desde} onChange={(e) => setFiltros({ ...filtros, desde: e.target.value })} style={input} /></Campo>
        <Campo label="Hasta"><input type="date" value={filtros.hasta} onChange={(e) => setFiltros({ ...filtros, hasta: e.target.value })} style={input} /></Campo>
        <button onClick={cargar} disabled={cargando} style={{ padding: '10px 18px', background: '#2563eb', color: 'white', border: 0, borderRadius: '7px', fontWeight: 'bold', cursor: 'pointer' }}>{cargando ? '⏳' : '🔍 Consultar'}</button>
      </div>
      <div style={{ background: 'white', padding: '15px', borderRadius: '10px', overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead><tr style={{ background: '#f1f5f9' }}>
            {['Fecha', 'Producto', 'Tipo', 'Movimiento', 'Stock anterior', 'Stock resultante', 'Usuario', 'Motivo'].map((h) => <th key={h} style={th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {movimientos.map((m) => <tr key={m.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
              <td style={td}>{new Date(m.fecha).toLocaleString('es-AR')}</td>
              <td style={{ ...td, fontWeight: 'bold' }}>{m.descripcion}</td>
              <td style={td}>{m.tipo}</td>
              <td style={{ ...td, fontWeight: 'bold', color: Number(m.cantidad) >= 0 ? '#15803d' : '#dc2626' }}>{Number(m.cantidad) >= 0 ? '+' : ''}{Number(m.cantidad).toLocaleString('es-AR', { maximumFractionDigits: 3 })}</td>
              <td style={td}>{Number(m.stock_anterior).toLocaleString('es-AR', { maximumFractionDigits: 3 })}</td>
              <td style={td}>{Number(m.stock_resultante).toLocaleString('es-AR', { maximumFractionDigits: 3 })}</td>
              <td style={td}>{m.usuario || 'Sistema'}</td>
              <td style={td}>{m.motivo || '-'}</td>
            </tr>)}
            {!movimientos.length && <tr><td colSpan="8" style={{ padding: '30px', textAlign: 'center', color: '#94a3b8' }}>No hay movimientos para los filtros elegidos.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Campo({ label, children }) { return <div><label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#475569', marginBottom: '5px' }}>{label}</label>{children}</div>; }
const input = { padding: '9px', border: '1px solid #cbd5e1', borderRadius: '6px', minWidth: '150px' };
const th = { padding: '10px', textAlign: 'left', color: '#334155', borderBottom: '2px solid #cbd5e1' };
const td = { padding: '10px', color: '#475569', verticalAlign: 'top' };
